import { createRoute } from '@tanstack/react-router';
import type { AnyRoute } from '@tanstack/react-router';
import { HrAttendance } from './HrAttendance';
import { HrContract } from './HrContract';
import { HrDecision } from './HrDecision';
import { HrDecisionDetail } from './HrDecisionDetail';
import { HrKpi } from './HrKpi';
import { HrReview } from './HrReview';
import { HrScreen } from './HrScreen';
import { StaffProfile } from './StaffProfile';

// Lớp NHÂN SỰ của Mee: /mee/hr… (chuyển từ /ezy/hr…, QĐ anh David 01/Nov 14:43)
export const hrRoutes = (parent: AnyRoute): AnyRoute[] => [
  createRoute({ getParentRoute: () => parent, path: 'hr', component: HrScreen }),
  createRoute({ getParentRoute: () => parent, path: 'hr/attendance', component: HrAttendance }),
  createRoute({ getParentRoute: () => parent, path: 'hr/contract', component: HrContract }),
  createRoute({ getParentRoute: () => parent, path: 'hr/decision', component: HrDecision }),
  createRoute({ getParentRoute: () => parent, path: 'hr/decision/$no', component: HrDecisionDetail }),
  createRoute({ getParentRoute: () => parent, path: 'hr/kpi', component: HrKpi }),
  createRoute({ getParentRoute: () => parent, path: 'hr/review', component: HrReview }),
  createRoute({ getParentRoute: () => parent, path: 'hr/profile', component: StaffProfile }),
  createRoute({ getParentRoute: () => parent, path: 'hr/profile/$staffId', component: StaffProfile }),
];
